module.exports = __webpack_public_path__ + "img/how-work-2.b2ea06ae.png";